import EditAccountNameScreen from 'features/accounts/ManageAccount/ManageAccountNickname/EditAccountNameScreen';

export default function EditAccountNamePage() {
  return <EditAccountNameScreen />;
}
